<template>
  <div class="empty">
    暂无数据
  </div>
</template>
<script>
  export default {
    name: 'empty',
  }
</script>
<style scoped>
  .empty {
    text-align: center;
    padding: 50px 0;
    background: #ffffff;
    margin-top: 10px;
  }
</style>





// WEBPACK FOOTER //
// src/components/commen/empty.vue